import React from 'react'
import { useTranslation } from 'react-i18next'
import { activePreviews } from 'utils/previewFlags'

/**
 * A slim bar above the page content while any preview switch is on in this
 * browser, so it's obvious that ?preview=… took effect (the parameter itself
 * is stripped from the address bar) and one click turns it off again.
 *
 * In the flow of the page, not floating: a fixed badge covered the action
 * buttons of the bottom row.
 */
const PreviewBadge: React.FC = () => {
  const { t } = useTranslation()
  const names = activePreviews()
  if (names.length === 0) return null

  return (
    <div
      role="status"
      className="mx-2 mt-2 sm:mx-4 flex items-center justify-between gap-2 rounded-md border border-amber-300 bg-amber-50 px-3 py-1 text-xs text-amber-900"
    >
      <span>{t('Preview.active', { names: names.join(', ') })}</span>
      {/* A full load, so applyPreviewParam() handles it at startup like any other ?preview= link. */}
      <a className="font-semibold underline" href={`${window.location.pathname}?preview=off`}>
        {t('Preview.turnOff')}
      </a>
    </div>
  )
}

export default PreviewBadge
